import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { PcodeAds } from '../../typings/pcode';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';
import { openConstructor } from '../AddCreativePage/actions';
import { CanvasAction } from '../common/actions';
import { Page } from '../common/typings';

import {
    applyFilter,
    closeCampaignsList,
    closePreview,
    enableEditMode,
    getCampaigns,
    getPreview,
    hideError,
    loadItems,
    nameChange,
    resetNameToInitial,
    saveName,
    setSelection,
    submit,
    toggleItemSelection,
    togglePlaySound
} from './actions';
import { VideoCreativesProps } from './typings';
import { VideoCreatives } from './VideoCreatives';

type OwnProps = {
    cancel: () => void;
    creativesSelect: (ids: number[]) => void;
    videoPreviewData?: PcodeAds;
};
type DispatchProps = TDispatchProps<VideoCreativesProps, OwnProps>;
const mapDispatchToProps = (dispatch: Dispatch<CanvasAction>, ownProps: OwnProps): DispatchProps => {
    return {
        filterChange: (val: string, showTied: boolean) => dispatch(applyFilter(val, showTied)),
        getCampaigns: (id: string) => dispatch(getCampaigns(id)),
        closeCampaignsList: () => dispatch(closeCampaignsList()),
        submit: () => dispatch(submit(ownProps.creativesSelect)),
        preview: (id: string) => dispatch(getPreview(id, ownProps.videoPreviewData)),
        togglePlaySound: () => dispatch(togglePlaySound()),
        toggleItemSelection: (id: string) => dispatch(toggleItemSelection(id)),
        setSelection: (id: string) => dispatch(setSelection(id)),
        enableEditMode: (id: string, enabled: boolean) => dispatch(enableEditMode(id, enabled)),
        nameChange: (id: string, val: string) => dispatch(nameChange(id, val)),
        saveName: (id: string) => dispatch(saveName(id)),
        resetNameToInitial: (id: string) => dispatch(resetNameToInitial(id)),
        hideError: () => dispatch(hideError()),
        loadItems: (offset: number, filter: string, showTied: boolean) => dispatch(loadItems(offset, filter, showTied)),
        closePreview: () => dispatch(closePreview()),
        openConstructor: (id: string) => dispatch(openConstructor(Page.CREATIVES, undefined, id))
    };
};

type StateProps = TStateProps<VideoCreativesProps>;
export const mapStateToProps = (state: State): StateProps => {
    return state.canvasEditor.canvas.videoCreatives;
};

const mergeProps = (stateProps: StateProps, dispatchProps: DispatchProps, ownProps: OwnProps): VideoCreativesProps => {
    const { creativesSelect, ...otherProps } = ownProps;

    return {
        ...stateProps,
        ...dispatchProps,
        ...otherProps
    };
};

export const VideoCreativesContainer = connect<StateProps, DispatchProps, OwnProps, VideoCreativesProps>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(VideoCreatives);
